import * as React from 'react'
import {
	Box,
	Link,
	Stack,
	Typography,
	type BoxProps,
	type LinkProps,
	type StackProps,
	type TypographyProps,
} from '@mui/material'
import { ArrowBack } from '@mui/icons-material'
import { styled } from '@mui/material/styles'

export const PageWrapper: React.FC<BoxProps> = styled( Box )<BoxProps>( ( { theme } ) => ( {
	margin: theme.spacing( 4, 6 ),
	height: `calc(100vh - ${theme.spacing( 8 )})`,
	display: 'flex',
	flexDirection: 'column',
	[ theme.breakpoints.down( 'sm' ) ]: {
		margin: theme.spacing( 2, 3 ),
	},
} ) )

export const BreadcrumbsLink: React.ComponentType<LinkProps> = styled( Link )( ( { theme } ) => ( {
	'textDecoration': 'none',
	'textAlign': 'center',
	'display': 'flex',
	'alignItems': 'center',
	'color': theme.palette.primary.main,
	'&:hover': {
		textDecoration: 'underline',
	},
} ) )

export const CenteredContainer: React.ComponentType<BoxProps> = styled( Box )( ( { theme } ) => ( {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '60vh',
	gap: theme.spacing( 3 ),
} ) )

export const ArrowBackIcon: React.FC = styled( ArrowBack )( ( { theme } ) => ( {
	color: theme.palette.primary.main,
	marginRight: theme.spacing( 1 ),
	width: theme.spacing( 2 ),
} ) )

export const ManageTitle: React.FC<TypographyProps> = styled( Typography )<TypographyProps>( ( { theme } ) => ( {
	color: theme.palette.text.primary,
	marginTop: theme.spacing( 2 ),
	fontSize: theme.typography.h2.fontSize,
	fontWeight: theme.typography.fontWeightBold,
} ) )

export const PageSection: React.ComponentType<StackProps> = styled( Stack )<StackProps>( ( ) => ( {
	height: '100%',
} ) )
